import { render, staticRenderFns } from "./CardStatus.vue?vue&type=template&id=4aae97ce&scoped=true&"
import script from "./CardStatus.vue?vue&type=script&lang=js&"
export * from "./CardStatus.vue?vue&type=script&lang=js&"
import style0 from "./CardStatus.vue?vue&type=style&index=0&id=4aae97ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aae97ce",
  null
  
)

export default component.exports